module.exports = __webpack_public_path__ + "img/fengxianpinggu1.28dc43de.png";